import * as React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import MaterialTable, { Column } from 'material-table';
import Fab from '@material-ui/core/Fab';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import { RowDataLive } from 'src/reducers/liveorderfile';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Checkbox, FormControlLabel, IconButton, MenuItem, Select, withStyles } from '@material-ui/core';
import RedoIcon from '@material-ui/icons/Redo';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@material-ui/core/Button';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    FormControl,
    TextField,
    DialogProps,
    Typography,
    Box
} from '@material-ui/core';
import DescriptionSharpIcon from '@material-ui/icons/DescriptionSharp';
import { forwardRef } from 'react';
import { Icons } from 'material-table';
import { RedesignReasons, RowDataCompleted } from 'src/reducers/completeorderfile';
import { ManufacturerData, TatData } from 'src/reducers/fileUpload';
import PlayCircleFilledTwoToneIcon from '@material-ui/icons/PlayCircleFilledTwoTone';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@material-ui/core';

interface TableState {
    columns: Array<Column<RowDataLive>>;
    data: RowDataLive[];
}

interface SubitReDesignCodes {
    producttype: string;
    category: string;
    reason: string;
}

export interface ReturnOrderPageViewProps {
    liveOrderDataReturned: RowDataLive[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (orderno: string, fileName: string) => void;
    approvalRequired: (array: Array<object>) => void;
    redesignReasons: RedesignReasons[];
    orderDataTat: TatData[];
    orderDataManufacturer: ManufacturerData[];
    redesignRequest: (columns: Object) => void;

    isDownloading: boolean;
    // onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted) => void;
    onBulkDownload: (completedData: RowDataCompleted[] | RowDataCompleted, isRetry?: boolean) => void;
    onBulkDownloadStl: (completedData: RowDataCompleted[] | RowDataCompleted, filetype: string) => void;

    openVideoPlayerURL: (fullPath: string[], fpath: string) => void;
    failedFiles: Array<{ fname: string; orderno: string; fileType?: string; caseCount?: number }>;
    showFailedFilesDialog: boolean;
    failedFilesMessage: string;
    closeFailedFilesDialog: () => void;
}
export const tableIcons: Icons = {
    Export: forwardRef((props, ref) => <DescriptionSharpIcon {...props} ref={ref} />)
};

const CssTextField = withStyles({
    root: {
        '& .MuiInputBase-root.Mui-disabled': {
            color: '#000',
            fontSize: '0.9rem'
        },
    },
})(TextField);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            height: 'calc(90vh - 64px)'
        },
        table: {
            // margin: theme.spacing(1),
            minWidth: 800,
        },
        forms: {
            width: '100%', // Fix IE 11 issue.
        },
        buttonSend: {
            // margin: theme.spacing(1),
            float: 'right',
            zIndex: 100,
            margin: '10px'
        },
        root1: {
            display: 'flex',
            height: '30vh'
        },
        fileUpload: {
            textAlign: 'center',
            fontSize: '18px',
            color: '#808080',
            height: '20vh',
            border: '2px solid #808080',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderStyle: 'dotted',
            '&:hover': {
                border: '4px solid #ff0000'
            }
        },
        iconbutton: {
            display: 'flex',
            '& > *': {
                margin: theme.spacing(1),
            },
            justifyContent: 'center'
        },
        paper: {
            backgroundColor: theme.palette.background.paper,
            borderRadius: '5px',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(1),
        },
        HeadinG: {
            margin: theme.spacing(1),
            '& .MuiInputBase-input': {
                fontSize: '0.9rem'
            },
            '& .MuiButton-label': {
                fontSize: '0.7rem'
            },
            fontSize: '0.9rem'
        },
        iconPadding: {
            padding: '6px'
        },
        button: {
            margin: theme.spacing(1),
        },
        textArea: {
            display: 'flex',
            justifyContent: 'center',
            margin: '20px'
        },
        qcreq: {
            fontSize: '10px',
            textAlign: 'right',
            paddingRight: '24px',
            fontStyle: 'italic',
            color: 'red'
        },
        reasonBox: {
            minWidth: '500px'
        }
    })
);

const ReturnOrderPageView: React.StatelessComponent<ReturnOrderPageViewProps> = (props) => {
    const classes = useStyles({});
    // const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

    // const popoverClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    //     setAnchorEl(event.currentTarget);
    // };

    // const popoverClose = () => {
    //     setAnchorEl(null);
    // };

    // const open = Boolean(anchorEl);
    // const id = open ? 'simple-popover' : undefined;

    // const [titleName, setTitle] = React.useState('');
    // const [openDialog, setOpen] = React.useState(false);
    // const handleClickOpen = (title: string) => {
    //     setTitle(title);
    //     setOpen(true);
    // };
    // const handleClose = () => {
    //     setOpen(false);
    // };
    // const [restartDialog, setRestart] = React.useState(false);
    // const handleClickOpenRestart = () => {
    //     setRestart(true);
    // };
    // const handleRestartClose = () => {
    //     setRestart(false);
    // };
    const [fullWidth] = React.useState(true);
    const [maxWidth] = React.useState<DialogProps['maxWidth']>('sm');

    const [fullWidthRe] = React.useState(true);
    const [maxWidthRe] = React.useState<DialogProps['maxWidth']>('md');

    const [fullWidthDownload] = React.useState(true);
    const [maxWidthDownload] = React.useState<DialogProps['maxWidth']>('xs');

    const [msgApp, setMsgApp] = React.useState('');
    const [orderno, setOrderno] = React.useState('');
    const [openAppro, setOpenAppro] = React.useState(false);

    const [tat, setTat] = React.useState('Next Day 7 AM');
    const [manufactType, saveManufactType] = React.useState('In-House');
    const [ptype, setPtype] = React.useState('');
    const [ptypeModel, setPtypeModel] = React.useState('');
    const [category, setCategory] = React.useState('');
    const [categoryArray, setCategoryArray] = React.useState<string[]>([]);
    const [categoryModelArray, setCategoryModelArray] = React.useState<string[]>([]);
    const [categoryModel, setCategoryModel] = React.useState('');
    const [reason, setReason] = React.useState<SubitReDesignCodes[]>([]);
    const [reasonModel, setReasonModel] = React.useState<SubitReDesignCodes[]>([]);
    const [msg, setMsg] = React.useState('');
    const [userName, setuserName] = React.useState('');

    const handleClickOpenApp = (ordernumber: string) => {
        setMsgApp('');
        setOrderno(ordernumber);
        setOpenAppro(true);
    };
    const handleCloseApp = () => {
        setOpenAppro(false);
    };
    const handleSubmitApp = () => {
        setOpenAppro(false);
        const array = [{
            orderno: orderno,
            approval_reqd: '1',
            remarks: msgApp
        }];
        props.approvalRequired(array);
    };
    const msgAppChange = (msgValue: string) => {
        setMsgApp(msgValue);
    };

    const [openRe, setOpenRe] = React.useState(false);
    const [openDesignReason, setOpenDesignReason] = React.useState(false);
    const [openModelReason, setOpenModelReason] = React.useState(false);

    const duplicateCateDesign = (data: RedesignReasons[]) => {
        return Array.from(new Set(data.map(a => a.category)))
            .map(id => {
                return data.find(a => a.category === id && a.producttype !== 'Model');
            });
    };

    const duplicateCateModel = (data: RedesignReasons[]) => {
        return Array.from(new Set(data.map(a => a.category)))
            .map(id => {
                return data.find(a => a.category === id && a.producttype === 'Model');
            });
    };

    const changeDesignCategory = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            setCategory(event.target.value);
            setOpenDesignReason(true);
        } else {
            setReason(reason.filter((allReasons) => allReasons.category !== event.target.value));
            const indexofCheck = categoryArray.indexOf(event.target.value);
            categoryArray.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setCategoryArray(categoryArray);
        }
    };
    const changeModelCategory = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            setCategoryModel(event.target.value);
            setOpenModelReason(true);
        } else {
            setReasonModel(reasonModel.filter((allReasons) => allReasons.category !== event.target.value));
            const indexofCheck = categoryModelArray.indexOf(event.target.value);
            categoryModelArray.splice(indexofCheck !== -1 ? indexofCheck : 0, 1);
            setCategoryModelArray(categoryModelArray);
        }
    };

    const changeDesignReason = (event: React.ChangeEvent<HTMLInputElement>) => {

        const newArray: SubitReDesignCodes = {
            producttype: 'Design',
            category: category,
            reason: event.target.value
        };
        reason.push(newArray);
        setReason(reason);
        categoryArray.push(category);
        setCategoryArray(categoryArray);
        setOpenDesignReason(false);
    };
    const changeModelReason = (event: React.ChangeEvent<HTMLInputElement>) => {

        const newArrayModel: SubitReDesignCodes = {
            producttype: 'Model',
            category: categoryModel,
            reason: event.target.value
        };
        reasonModel.push(newArrayModel);
        setReasonModel(reasonModel);
        categoryModelArray.push(categoryModel);
        setCategoryModelArray(categoryModelArray);
        setOpenModelReason(false);
    };

    const handleClickOpenRe = (ordernumber: string, uname: string, dest: string) => {
        setMsg('');
        setPtype('Design');
        setPtypeModel('Model');
        setCategory('0');
        setCategoryModel('0');
        setOrderno(ordernumber);
        saveManufactType(dest);
        setuserName(uname);
        setTat('Next Day 7 AM');
        setOpenRe(true);
        setReasonModel([]);
        setReason([]);
        setCategoryModelArray([]);
        setCategoryArray([]);
    };

    const handleCloseRe = () => {
        setOpenRe(false);
    };
    const onCloseDesignReason = () => {
        setOpenDesignReason(false);
    };
    const onCloseModelReason = () => {
        setOpenModelReason(false);
    };
    const handleSubmitRe = () => {
        const columns = {
            columns: {
                customer: userName,
                caseno: orderno,
                tat: tat,
                destination: manufactType,
                msg: msg.replace(/[\n\r]+/g, ' ').replace(/\s{2,}/g, ' ').replace(/^\s+|\s+$/, '').replace(/\"/g, '')
            },
            reasons: reason.concat(reasonModel),
            id: 'rword'
        };
        setOpenRe(false);
        props.redesignRequest(columns);
    };

    const downloadFiletypes = ['STL', 'PTS', '3OX'];
    const [openDownload, setOpenDownload] = React.useState(false);
    const [fileTypes, setFileTypes] = React.useState<string[]>([]);
    const [rowDatastl, setRowData] = React.useState<RowDataCompleted[] | RowDataCompleted>([]);

    const openDownloadDialog = (rowdata: RowDataCompleted[] | RowDataCompleted) => {
        setRowData(rowdata);
        setFileTypes([]);
        setOpenDownload(true);
    };
    const filetypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.checked === true) {
            fileTypes.push(event.target.value);
            const tempType = fileTypes.filter((v, i) => fileTypes.indexOf(v) === i);
            setFileTypes(tempType);
        } else {
            setFileTypes(fileTypes.filter((allTypes) => allTypes !== event.target.value));
        }
    };

    const closeDownloadDialog = () => {
        setOpenDownload(false);
    };
    const submitStlDownload = () => {
        setOpenDownload(false);
        props.onBulkDownloadStl(rowDatastl, fileTypes.toString());
    };

    const [state] = React.useState<TableState>({
        columns: [
            {
                title: 'Order No',
                field: 'orderno',
                filtering: false,
                render: rowData => (
                    <div>
                        {
                            rowData.qc_required === '0' ?
                                rowData.orderno
                                :
                                rowData.qc_required === '1' ?
                                    <div>
                                        {rowData.orderno}
                                        <div className={classes.qcreq}>
                                            QC Required
                                        </div>
                                    </div>
                                    :
                                    rowData.qc_required === '2' ?
                                        <div>
                                            {rowData.orderno}
                                            <div className={classes.qcreq} onClick={() => handleClickOpenApp(rowData.orderno)} style={{ color: 'green', cursor: 'pointer' }}>
                                                Approve
                                            </div>
                                        </div>
                                        :
                                        rowData.orderno
                        }
                    </div>
                ),
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '13px'
                }
            },
            // {
            //     title: 'Booking ID',
            //     field: 'refno',
            //     filtering: false,
            //     cellStyle: {
            //         padding: '5px 10px',
            //         fontSize: '13px'
            //     }
            // },
            {
                title: 'Uploaded On',
                field: 'orderdate',
                filtering: false,
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '13px'
                }
            },
            {
                title: 'File Name',
                field: 'fname',
                filtering: false,
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '13px'
                }
            },
            {
                title: 'TAT',
                field: 'tat',
                filtering: false,
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '13px'
                }
            },
            {
                title: 'Due By',
                field: 'dueby',
                filtering: false,
                cellStyle: {
                    padding: '5px 10px',
                    fontSize: '13px'
                }
            },
            {
                title: 'Action',
                field: 'orderno',
                filtering: false,
                export: false,
                render: rowData => (
                    <div style={{ margin: 'auto' }}>
                        <Tooltip title="View" placement="top">
                            <IconButton
                                aria-label="view"
                                onClick={() => props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid))}
                            // className={classes.iconPadding}
                            >
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Re-Design" placement="top">
                            <IconButton aria-label="view" onClick={() => handleClickOpenRe(rowData.orderno, rowData.labname, rowData.destination)}>
                                <RedoIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                        {
                            rowData.vfiles !== '' ?
                                <Tooltip title="Video" placement="top">
                                    <IconButton
                                        color="primary"
                                        onClick={() => props.openVideoPlayerURL(rowData.vfiles.split(','), rowData.fpath)}
                                        aria-label="view video"
                                    >
                                        <PlayCircleFilledTwoToneIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                                : null
                        }
                        {/* <Tooltip title="View" placement="top">
                            <IconButton
                                aria-label="view"
                                onClick={popoverClick}
                            // className={classes.iconPadding}
                            >
                                <SupervisedUserCircleIcon fontSize="small" />
                            </IconButton>
                        </Tooltip> */}
                        {/* <Tooltip title="Download" placement="top">
                            <IconButton
                                aria-label="view"
                                onClick={() => props.onDownloadClick((JSON.parse(JSON.stringify(rowData)).fpath), (JSON.parse(JSON.stringify(rowData)).fname))}
                            // className={classes.iconPadding}
                            >
                                <CloudDownloadIcon fontSize="small" />
                            </IconButton>
                        </Tooltip> */}
                    </div>
                ),
                cellStyle: {
                    padding: '0px',
                    textAlign: 'center'
                }
            },
        ],
        data: props.liveOrderDataReturned
    });
     // Add these new state variables in the component
    const [selectedFailedFiles, setSelectedFailedFiles] = React.useState<Array<{ fname: string; orderno: string }>>([]);

    // Add these handler functions
    const handleFailedFileCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>, file: { fname: string; orderno: string }) => {
        if (event.target.checked) {
            setSelectedFailedFiles([...selectedFailedFiles, file]);
        } else {
            setSelectedFailedFiles(selectedFailedFiles.filter(item =>
                !(item.fname === file.fname && item.orderno === file.orderno)
            ));
        }
    };

    const handleSelectAllFailedFiles = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked) {
            setSelectedFailedFiles([...props.failedFiles]);
        } else {
            setSelectedFailedFiles([]);
        }
    };
    const [retryCountMap, setRetryCountMap] = React.useState<Record<string, number>>({});
    React.useEffect(
            () => {
            if (props.showFailedFilesDialog) {
                // Initialize retry counts for any new files
                const newRetryCountMap = {...retryCountMap};
                props.failedFiles.forEach(file => {
                const fileKey = `${file.orderno}-${file.fname}`;
                if (newRetryCountMap[fileKey] === undefined) {
                    newRetryCountMap[fileKey] = 0;
                }
                });
                setRetryCountMap(newRetryCountMap);
                
                // Automatically select all files that haven't exceeded retry limit
                const availableFiles = props.failedFiles.filter(file => {
                const fileKey = `${file.orderno}-${file.fname}`;
                return (newRetryCountMap[fileKey] || 0) < 3;
                });
                
                // Set the selected files
                setSelectedFailedFiles(availableFiles);
            }
            },
            [props.showFailedFilesDialog, props.failedFiles]
        );
    
        // Modify the handleRetryDownload function to track retry counts
    const handleRetryDownload = () => {
        if (selectedFailedFiles.length > 0) {
            // Update retry counts for selected files
            const updatedRetryCountMap = {...retryCountMap};
            selectedFailedFiles.forEach(file => {
                const fileKey = `${file.orderno}-${file.fname}`;
                updatedRetryCountMap[fileKey] = (updatedRetryCountMap[fileKey] || 0) + 1;
            });
            setRetryCountMap(updatedRetryCountMap);
            
            // Create filtered list with only files that haven't exceeded retry limit
            const filesToDownload = props.liveOrderDataReturned.filter(item =>
                selectedFailedFiles.some(file => {
                    const fileKey = `${file.orderno}-${file.fname}`;
                    const retryCount = updatedRetryCountMap[fileKey] || 0;
                    return file.fname === item.fname && file.orderno === item.orderno && retryCount <= 3;
                })
            );
            props.closeFailedFilesDialog();
            
            if (filesToDownload.length > 0) {
                props.onBulkDownload(filesToDownload, true);
            }
        }
    };

    // Helper function to check if a file has exceeded retry limit
    const hasExceededRetryLimit = (file: { fname: string; orderno: string }): boolean => {
        const fileKey = `${file.orderno}-${file.fname}`;
        return (retryCountMap[fileKey] || 0) >= 3;
    };

    // Helper function to get number of retries for a file
    const getRetryCount = (file: { fname: string; orderno: string }): number => {
        const fileKey = `${file.orderno}-${file.fname}`;
        return retryCountMap[fileKey] || 0;
    };
    const stfFailedFiles = props.failedFiles.filter(file => file.fileType === 'STL');
 
    return (
        <div className={classes.root}>
            <Grid container justify="center" alignItems="center" >
                <Grid item xs={12} sm={12} md={12}>
                    <div>
                        <Fab color="primary" aria-label="add" style={{ height: '40px', width: '40px', float: 'left', margin: '12px', zIndex: 100 }} onClick={props.reload}>
                            <AutorenewIcon />
                        </Fab>
                    </div>
                    {/* <Popover
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        onClose={popoverClose}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <div>
                            <Button
                                variant="contained"
                                color="secondary"
                                className={classes.button}
                                startIcon={<DeleteIcon />}
                                onClick={() => handleClickOpen('Cancel')}
                            >
                                Cancel
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                className={classes.button}
                                endIcon={<RestoreIcon />}
                                onClick={() => handleClickOpen('Re-Start')}
                            >
                                Re-start
                            </Button>
                        </div>
                    </Popover>
                    <Dialog
                        open={openDialog}
                        onClose={handleClose}
                        fullWidth
                        maxWidth="sm"
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{`${titleName}`}</DialogTitle>
                        <DialogContent dividers>
                            <DialogContentText id="alert-dialog-description">
                                Are you sure to {`${titleName}`} this Order ?
                                <div className={classes.textArea}>
                                    <TextField
                                        id="outlined-multiline-static"
                                        label="Remarks"
                                        fullWidth
                                        multiline
                                        rows={4}
                                        // defaultValue="Default Value"
                                        variant="outlined"
                                    />
                                </div>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose} color="primary">
                                No
                            </Button>
                            <Button onClick={handleClose} color="primary" autoFocus>
                                Yes
                            </Button>
                        </DialogActions>
                    </Dialog> */}
                    {/* <Dialog
                        open={restartDialog}
                        onClose={handleRestartClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">Re-Start?</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                Are You Sure to Re-Start this Order
                        </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleRestartClose} color="primary">
                                No
                            </Button>
                            <Button onClick={handleRestartClose} color="primary" autoFocus>
                                Yes
                            </Button>
                        </DialogActions>
                    </Dialog> */}
                    <Dialog
                        open={props.showFailedFilesDialog && props.failedFiles.length > 0 && stfFailedFiles.length === 0}
                        onClose={props.closeFailedFilesDialog}
                        aria-labelledby="failed-files-dialog-title"
                        fullWidth
                        maxWidth="sm"
                    >
                        <DialogTitle id="failed-files-dialog-title">
                            <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                Failed Downloads
                            </Typography>
                        </DialogTitle>
                        <DialogContent dividers>
                            {props.failedFiles && props.failedFiles.length > 0 && (
                                <div className={classes.failedFilesContainer}>
                                    <Box style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={selectedFailedFiles.length === props.failedFiles.length}
                                                    onChange={handleSelectAllFailedFiles}
                                                    color="primary"
                                                />
                                            }
                                            label="Select All"
                                        />
                                        <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: 'red' }}>
                                            Total: {props.failedFiles?.length}
                                        </Typography>
                                    </Box>
                                    <TableContainer component={Paper} className={classes.tableContainer}>
                                        <Table aria-label="failed files table" size="small">
                                            <TableHead style={{ backgroundColor: '#bdbdbd', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                <TableRow>
                                                    <TableCell padding="checkbox">Select</TableCell>
                                                    <TableCell>S.No</TableCell>
                                                    <TableCell>Order No</TableCell>
                                                    <TableCell>File Name</TableCell>
                                                    <TableCell>Retry Count</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {props.failedFiles.map((file, index) => {
                                                    const exceededLimit = hasExceededRetryLimit(file);
                                                    const retryCount = getRetryCount(file);

                                                    return (
                                                        <TableRow key={index}>
                                                            <TableCell padding="checkbox">
                                                                <Checkbox
                                                                    checked={selectedFailedFiles.some(item => item.fname === file.fname && item.orderno === file.orderno)}
                                                                    onChange={(event) => handleFailedFileCheckboxChange(event, file)}
                                                                    color="primary"
                                                                    disabled={exceededLimit}
                                                                />
                                                            </TableCell>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell>{file.orderno}</TableCell>
                                                            <TableCell>{file.fname}</TableCell>
                                                            <TableCell>
                                                                {retryCount}/3
                                                                {exceededLimit && (
                                                                    <Typography variant="caption" style={{ color: 'red', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                                        Max retries exceeded
                                                                    </Typography>
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={handleRetryDownload}
                                style={{
                                    backgroundColor: selectedFailedFiles.some(file => !hasExceededRetryLimit(file))
                                        ? '#1976d2' : '#f44336',
                                    color: 'white'
                                }}
                                variant="contained"
                                disabled={selectedFailedFiles.length === 0 || selectedFailedFiles.every(file => hasExceededRetryLimit(file))}
                            >
                                Retry Download
                            </Button>
                            <Button onClick={props.closeFailedFilesDialog} color="primary" variant="contained">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={props.showFailedFilesDialog && stfFailedFiles.length > 0}  // Show dialog only if there are STL files
                        onClose={props.closeFailedFilesDialog}
                        aria-labelledby="failed-files-dialog-title"
                        fullWidth
                        maxWidth="sm"
                    >
                        <DialogTitle id="failed-files-dialog-title">
                            <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                STL Files - Failed Downloads
                            </Typography>
                        </DialogTitle>
                        <DialogContent dividers>
                            {stfFailedFiles && stfFailedFiles.length > 0 && (
                                <div className={classes.failedFilesContainer}>
                                   
                                    <Box 
                                            style={{ 
                                                border: '1px solid #e0e0e0', 
                                                borderRadius: '4px', 
                                                padding: '12px', 
                                                marginBottom: '8px' 
                                            }}
                                    >
                                            <Box style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '2px' }}>
                                                <Typography variant="subtitle1" color="textSecondary">
                                                    Below files are not available. Please contact support team
                                                </Typography>
                                              
                                            </Box>
                                    </Box>
                                    <TableContainer component={Paper} className={classes.tableContainer}>
                                        <Table aria-label="failed files table" size="small">
                                            <TableHead style={{ backgroundColor: '#bdbdbd', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                                <TableRow>
                                                    <TableCell>S.No</TableCell>
                                                    <TableCell>Order No</TableCell>
                                                    <TableCell>File Name</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {stfFailedFiles.map((file, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell>{index + 1}</TableCell>
                                                        <TableCell>{file.orderno}</TableCell>
                                                        <TableCell>{file.fname}</TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            )}
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={props.closeFailedFilesDialog} color="primary" variant="contained">
                                Close
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={openRe}
                        aria-labelledby="Dialog-Order-Redesign"
                        fullWidth={fullWidthRe}
                        maxWidth={maxWidthRe}
                    >
                        <DialogTitle id="form-dialog-title">Re-Design Request on Order No : {orderno}</DialogTitle>
                        <DialogContent dividers>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={6} md={4}>
                                    {/* <FormControl size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined"
                                                defaultValue="0"
                                                onChange={(event) => setPtype(event.target.value as string)}
                                                value={ptype}
                                            >
                                                <MenuItem value="Design" disabled>Design</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicatePtype(props.redesignReasons).map((proType, indexRe1) => (
                                                    proType!.producttype !== 'Model' ? <MenuItem id={proType!.rowno} value={proType!.producttype}>{proType!.producttype}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                                    <CssTextField
                                        fullWidth
                                        disabled
                                        size="small"
                                        onChange={(event) => setPtype(event.target.value as string)}
                                        value={ptype}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container>
                                {/* <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-1"
                                                defaultValue="0"
                                                onChange={(event) => setCategory(event.target.value as string)}
                                                value={category}
                                            >
                                                <MenuItem value="0" disabled>Select Category</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicateCate(props.redesignReasons).map((cate, indexRe1) => (
                                                    cate!.producttype !== 'Model' ? <MenuItem id={cate!.rowno} value={cate!.category}>{cate!.category}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                                {
                                    duplicateCateDesign(props.redesignReasons).map((cate, indexRe1) => (
                                        typeof (cate) === 'object' && cate!.producttype !== 'Model' ?
                                            <Grid item key={indexRe1} xs={12} sm={6} md={3}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            id={`category${indexRe1}`}
                                                            checked={categoryArray.indexOf(cate!.category) !== -1 ? true : false}
                                                            value={cate!.category}
                                                            onChange={changeDesignCategory}
                                                            name="category"
                                                        />
                                                    }
                                                    label={<Typography variant="caption">{cate!.category}</Typography>}
                                                />
                                            </Grid>
                                            : null
                                    ))
                                }

                            </Grid>
                            <hr style={{ margin: '10px 0' }} />
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={6} md={4}>
                                    {/* <FormControl size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-3"
                                                defaultValue="0"
                                                onChange={(event) => setPtypeModel(event.target.value as string)}
                                                value={ptypeModel}
                                            >
                                                <MenuItem value="Model" disabled>Model</MenuItem>
                                            </Select>
                                        </FormControl> */}
                                    <CssTextField
                                        fullWidth
                                        disabled
                                        size="small"
                                        onChange={(event) => setPtypeModel(event.target.value as string)}
                                        value={ptypeModel}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container>
                                {/* <FormControl variant="outlined" size="small" className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-4"
                                                defaultValue="0"
                                                onChange={(event) => setCategoryModel(event.target.value as string)}
                                                value={categoryModel}
                                            >
                                                <MenuItem value="0" disabled>Select Category (Model)</MenuItem>
                                                {Array.isArray(props.redesignReasons) && props.redesignReasons.length > 0 && duplicateCate(props.redesignReasons).map((cateModel, indexRe1) => (
                                                    cateModel!.producttype === 'Model' ? <MenuItem id={cateModel!.rowno} value={cateModel!.category}>{cateModel!.category}</MenuItem> : null
                                                ))}
                                            </Select>
                                        </FormControl> */}
                                {
                                    duplicateCateModel(props.redesignReasons).map((cateModel, indexRe1) => (
                                        typeof (cateModel) === 'object' && cateModel!.producttype === 'Model' ?
                                            <Grid item key={indexRe1} xs={12} sm={6} md={3}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            id={`categoryModel${indexRe1}`}
                                                            checked={categoryModelArray.indexOf(cateModel!.category) !== -1 ? true : false}
                                                            value={cateModel!.category}
                                                            onChange={changeModelCategory}
                                                            name="category"
                                                        />
                                                    }
                                                    label={<Typography variant="caption">{cateModel!.category}</Typography>}
                                                />
                                            </Grid>
                                            : null
                                    ))
                                }
                            </Grid>
                            <hr style={{ margin: '10px 0' }} />
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={4}>
                                    <FormControl variant="outlined" size="small" className={classes.forms}>
                                        <Select
                                            id="demo-simple-select-outlined-6"
                                            defaultValue="Next Day 7 AM"
                                            onChange={(event) => setTat(event.target.value as string)}
                                            value={tat}
                                        >
                                            {Array.isArray(props.orderDataTat) && props.orderDataTat.length > 0 && props.orderDataTat.map((tatime, index1) => (
                                                <MenuItem key={index1} id={tatime.rowno} value={tatime.tattype}>{tatime.tattype}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={6} md={4}>
                                    <FormControl variant="outlined" size="small" className={classes.forms}>
                                        <Select
                                            labelId="demo-simple-select-outlined-label-red1"
                                            id="demo-simple-select-outlined-red1"
                                            required
                                            fullWidth
                                            onChange={(event) => saveManufactType(event.target.value as string)}
                                            value={manufactType}
                                        >
                                            <MenuItem disabled value="">
                                                <em>Destination</em>
                                            </MenuItem>
                                            <MenuItem value="In-House">
                                                In-House
                                            </MenuItem>
                                            {Array.isArray(props.orderDataManufacturer) && props.orderDataManufacturer.length > 0 && props.orderDataManufacturer.map((manufactTypes) => (
                                                <MenuItem id={manufactTypes.rowno} value={manufactTypes.dest}>{manufactTypes.dest}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12} sm={12} md={4}>
                                    <FormControl fullWidth variant="outlined" size="small">
                                        <TextField
                                            variant="outlined"
                                            label="Remarks"
                                            multiline
                                            // rows={3}
                                            rowsMax={5}
                                            size="small"
                                            onChange={(event) => setMsg(event.target.value as string)}
                                            value={msg}
                                            required
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: 'space-between' }}>
                            <Typography variant="caption">
                                *Please select Reason, TAT, Destination and enter Remarks to submit Re-Design.
                            </Typography>
                            <div>
                                <Button size="small" onClick={handleCloseRe} color="secondary">
                                    Cancel
                                </Button>
                                <Button
                                    size="small"
                                    disabled={(msg === '' || (reason.length === 0 && reasonModel.length === 0)) ? true : false}
                                    onClick={handleSubmitRe}
                                    color="primary"
                                >
                                    Re-Design
                                </Button>
                            </div>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={openDesignReason}
                        onClose={onCloseDesignReason}
                    >
                        <DialogTitle id="form-dialog-title-reasons">{category} :</DialogTitle>
                        <DialogContent dividers>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <div className={classes.reasonBox}>
                                        <FormControl variant="outlined" fullWidth className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-2"
                                                defaultValue="0"
                                                fullWidth
                                                onChange={changeDesignReason}
                                                value="0"
                                            >
                                                <MenuItem value="0" disabled>Select Reason</MenuItem>
                                                {Array.isArray(props.redesignReasons)
                                                    && props.redesignReasons.length > 0
                                                    && props.redesignReasons.map((reasonsRe, indexRe1) => (
                                                        reasonsRe.producttype !== 'Model' && reasonsRe.category === category ?
                                                            <MenuItem id={reasonsRe.rowno} value={reasonsRe.code}>{reasonsRe.codedesc}</MenuItem>
                                                            :
                                                            null
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </Dialog>
                    <Dialog
                        open={openModelReason}
                        onClose={onCloseModelReason}
                    >
                        <DialogTitle id="form-dialog-title-reasons">{categoryModel} :</DialogTitle>
                        <DialogContent dividers>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <div className={classes.reasonBox}>
                                        <FormControl variant="outlined" fullWidth className={classes.forms}>
                                            <Select
                                                id="demo-simple-select-outlined-5"
                                                defaultValue="0"
                                                fullWidth
                                                onChange={changeModelReason}
                                                value="0"
                                            >
                                                <MenuItem value="0" disabled>Select Reason (Model)</MenuItem>
                                                {Array.isArray(props.redesignReasons)
                                                    && props.redesignReasons.length > 0
                                                    && props.redesignReasons.map((reasonsModl, indexRe1) => (
                                                        reasonsModl.producttype === 'Model' && reasonsModl.category === categoryModel ?
                                                            <MenuItem id={reasonsModl.rowno} value={reasonsModl.code}>{reasonsModl.codedesc}</MenuItem>
                                                            :
                                                            null
                                                    ))}
                                            </Select>
                                        </FormControl>
                                    </div>
                                </Grid>
                            </Grid>
                        </DialogContent>
                    </Dialog>
                    <Dialog
                        open={openAppro}
                        onClose={handleCloseApp}
                        aria-labelledby="Dialog-Order-Redesign"
                        fullWidth={fullWidth}
                        maxWidth={maxWidth}
                    >
                        <DialogTitle id="form-dialog-title">Approve Design on Order No : {orderno}</DialogTitle>
                        <DialogContent dividers>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={12}>
                                    <FormControl fullWidth variant="outlined" size="small">
                                        <TextField
                                            variant="outlined"
                                            label="Remarks"
                                            multiline
                                            rows={3}
                                            rowsMax={5}
                                            size="small"
                                            onChange={(event) => msgAppChange(event.target.value as string)}
                                            value={msgApp}
                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button size="small" onClick={handleCloseApp} color="secondary">
                                Cancel
                            </Button>
                            <Button size="small" onClick={handleSubmitApp} disabled={msgApp === ''} color="primary">
                                Approve
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Dialog
                        open={openDownload}
                        onClose={closeDownloadDialog}
                        aria-labelledby="Dialog-Order-Redesign"
                        fullWidth={fullWidthDownload}
                        maxWidth={maxWidthDownload}
                    >
                        <DialogTitle id="form-dialog-title">What to download?</DialogTitle>
                        <DialogContent dividers>
                            <Grid container spacing={2}>
                                {
                                    downloadFiletypes.map((typeFile, indexRe1) => (
                                        <Grid item xs={6} sm={4} md={4}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        id={`filetype${indexRe1}`}
                                                        checked={fileTypes.indexOf(typeFile) > -1}
                                                        value={typeFile}
                                                        onChange={filetypeChange}
                                                        name="Filetype"
                                                    />
                                                }
                                                label={typeFile}
                                            />
                                        </Grid>
                                    ))
                                }
                            </Grid>
                        </DialogContent>
                        <DialogActions>
                            <Button size="small" onClick={closeDownloadDialog} color="secondary">
                                Cancel
                            </Button>
                            <Button size="small" onClick={submitStlDownload} disabled={fileTypes.length > 0 ? false : true} color="primary">
                                Download
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <MaterialTable
                        icons={tableIcons}
                        title="In Production"
                        columns={state.columns}
                        data={props.liveOrderDataReturned}
                        localization={{
                            toolbar: {
                                nRowsSelected: '{0} order(s) selected',
                                exportTitle: 'Export as Excel'
                            },
                            header: {
                                actions: ''
                            },
                            body: {
                                emptyDataSourceMessage: 'No orders to display'
                            }
                        }}
                        options={{
                            // filtering: true,
                            pageSizeOptions: [5, 10, 25, 50, 100],
                            sorting: true,
                            actionsColumnIndex: -1,
                            headerStyle: {
                                backgroundColor: '#757575',
                                color: '#fff',
                                padding: '5px',
                                textAlign: 'center'
                            },
                            rowStyle: {
                                padding: '0px 0px'
                            },
                            selection: true,
                            exportButton: true,
                            exportAllData: true,
                        }}
                        actions={[
                            {
                                icon: () => (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<CloudDownloadIcon />}
                                    >
                                        Download Zip
                                    </Button>),
                                tooltip: 'Download zip files',
                                isFreeAction: false,
                                onClick: (event, rowdata) => {

                                    if (!props.isDownloading) {
                                        props.onBulkDownload(rowdata);
                                    }
                                }
                            },
                            {
                                icon: () => (
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        startIcon={<CloudDownloadIcon />}
                                    >
                                        Download STL/PTS/3OX
                                    </Button>),
                                tooltip: 'Download STL/PTS/3OX files',
                                isFreeAction: false,
                                onClick: (event, rowdata) => {

                                    if (!props.isDownloading) {
                                        openDownloadDialog(rowdata);
                                    }
                                }
                            }
                            // {
                            //     tooltip: 'Download All files',
                            //     icon: 'view_column',
                            //     isFreeAction: true,
                            //     onClick: (evt, data) => {
                            //         if (!props.isDownloading) {
                            //             props.onBulkDownload(props.completeOrderData);
                            //         }
                            //     }
                            // }
                        ]}
                    // actions={[
                    //     {
                    //         icon: 'save_alt',
                    //         tooltip: 'Download',
                    //         onClick: (event, rowData) => {
                    //             // // ==> console.error(rowData);
                    //             props.onDownloadClick((JSON.parse(JSON.stringify(rowData)).fpath), (JSON.parse(JSON.stringify(rowData)).fname));
                    //             // props.onFileName(JSON.parse(JSON.stringify(rowData)).filename)
                    //             // alert(`You saved ${rowData[`orderno`]}`);
                    //         }
                    //     },
                    // {
                    //     icon: 'chevron_right',
                    //     tooltip: 'view',
                    //     onClick: (event, rowData) => props.onRowClick((JSON.parse(JSON.stringify(rowData)).orderno), (JSON.parse(JSON.stringify(rowData)).ds_ordersid))
                    // }
                    // ]}
                    />
                </Grid>
            </Grid>
        </div>
    );
};

export default ReturnOrderPageView;



// WEBPACK FOOTER //
// ./src/components/layouts/ReturnOrderPageView.tsx